import { MessageSquare, Sparkles } from 'lucide-react';

import type { TemplateAr } from '../../template-data';

export const automateSlackAlertsBasedOnTheCustomerIssueOrReportAr: TemplateAr =
  {
    name: 'أتمتة تنبيهات Slack حسب مشكلة العميل أو بلاغه بالذكاء الاصطناعي',
    shortName: 'أتمتة تنبيهات Slack لمشاكل العملاء بالذكاء الاصطناعي',
    description:
      'أرسل إشعارات Slack ذكية للفريق أو القناة المناسبة أول ما يكتشف الذكاء الاصطناعي مشكلة حرجة أو عميلاً عالي القيمة أو سبباً للتصعيد.',
    category: 'دعم العملاء',
    workflow: [
      { icon: MessageSquare, label: 'مشكلة' },
      { icon: Sparkles, label: 'الـ AI يكتشف' },
      { icon: MessageSquare, label: 'تنبيه Slack', final: true },
    ],
    detailDescription: {
      paragraph1:
        'خلّ فريقك يعرف أول ما تصير المشكلة، مو في اجتماع الصباح. الـ AI يكتشف الموقف اللي يحتاج انتباهاً فورياً — عطل حرج، أو عميل VIP منزعج، أو مخالفة امتثال، أو أي سبب للتصعيد — وينبّه الفريق أو القناة المناسبة تلقائياً. ومع كل إشعار يرفق السياق المطلوب وبيانات العميل والإجراء المقترح.',
      paragraph2:
        'التنبيه يوصل لقناة أو شخص أو مجموعة محددة، حسب نوع المشكلة وخطورتها وهيكل فريقك. والنظام يشتغل داخل مساحة عملك في Slack، ويحترم تفضيلات الإشعارات عندك. وأنماط التنبيه وقواعد التوجيه تتطوّر حسب نتائج المعالجة.',
    },
    benefits: [
      'الـ AI يلقط المشكلة الحرجة فوراً',
      'التنبيه يوصل للفريق المناسب',
      'كل إشعار يجي ومعه السياق كامل',
      'زمن الاستجابة للتصعيد ينزل',
      'يمنع تسرّب العملاء استباقياً',
      'خصّص قواعد التنبيه والمحفّزات على كيفك',
    ],
  };
